(function ($) {

  let searchedWord = $(".site-search-form-input").val();
  if(searchedWord) {
    console.log(searchedWord);
    highlightWord('.js-search-results-heading', searchedWord);
    highlightWord('.js-search-results-excerpt', searchedWord);
  }
 
  var loadmoreAnimationHtml =
    '<div class="col-12 text-center reload js-lm-spinner"><svg class="d-block mx-auto" width="100" height="100" viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" stroke="rgb(148, 82, 186)" stroke-width="4" fill="none" stroke-dasharray="31.4 31.4" stroke-dashoffset="31.4"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="0 25 25;360 25 25"></animateTransform></circle></svg></div>';

  $(".site-search-form-input").keyup(function (e) {
    var charTyped = String.fromCharCode(e.which);
    let searchInput = $(".site-search-form-input");

    if (searchInput.val().length < 3) {
      $("#site-search").removeClass("active");
      $(".search-results-preview").html("");
      $(".top-results").show();
      $(".search-button").removeClass("active");
    }


    $(".site-search").addClass('active');    

    if (
      (/[a-z\d]/i.test(charTyped) || e.which == 8) &&
      searchInput.val().length > 2
    ) {
      autoCompleteFilter(searchInput.val());

      return false;
    }
  });

  $(".no-results-form input[type=text]").keyup(function (e) {
    var charTyped = String.fromCharCode(e.which);
    let searchInput = $(".no-results-form input[type=text]");

    if (searchInput.val().length < 3) {
      $(".searchpageform.no-results-form").removeClass("active");
      $(".search-noresults-preview").html("");
    }

    $(".site-search").addClass('active');    

    if (
      (/[a-z\d]/i.test(charTyped) || e.which == 8) &&
      searchInput.val().length > 2
    ) {
      autoCompleteFilter(searchInput.val(), true);
    }

    return false;
  });

  function autoCompleteFilter(searchTerm, noResultsPage = false) {
    const args = {};
    args["paged"] = 1;
    args["post_status"] = "publish";
    args["posts_per_page"] = "4";

    if (searchTerm) args["s"] = searchTerm;

    if (noResultsPage) {
      $(".search-noresults-preview").html(loadmoreAnimationHtml);
      args["noResultsPage"] = "true";
    } else {
      $(".search-results-preview").html(loadmoreAnimationHtml);
    }

    getAjaxSearchAutocomplete(args);
  }

  function getAjaxSearchAutocomplete(args) {
    args["action"] = "search_autocomplete";
    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      type: "POST",
      data: args,
      success: function (data) {
        $(".reload").remove();
        if (args["paged"] == 1) {
          if (args["noResultsPage"]) {
            $(".site-search").addClass("active");
            $(".search-noresults-preview").html(data);
    
            highlightWord('.js-search-results-heading', args["s"]);
            highlightWord('.js-search-results-excerpt', args["s"]);

          } else {
            $(".site-search").addClass("active");
            $(".top-results").hide();
            $(".search-results-preview").html(data);
            highlightWord('.js-search-results-heading', args["s"]);
            highlightWord('.js-search-results-excerpt', args["s"]);
          }
        } else {
          $(".js-search-results").append(data);
          highlightWord('.js-search-results-heading', args["s"]);
          highlightWord('.js-search-results-excerpt', args["s"]);
        }
      },
    });
  }

  //ajax loadmore searchpage listing
  $(document).on("click", ".search-loadmore-js", function (e) {
    const args = {};
    let categoryAttr = $(this).attr("data-category");
    e.preventDefault();
    args["paged"] = 1;
    args["post_status"] = "publish";
    args["posts_per_page"] = "10";
    args["paged"] = Number($(this).attr("data-paged")) + 1;
    args["s"] = $(this).attr("data-searched");
    if (typeof categoryAttr !== "undefined" && categoryAttr !== false) {
      args["filteredCategory"] = categoryAttr;
    }

    $(this).parent().remove();

    $(".js-search-results").append(loadmoreAnimationHtml);
    getAjaxSearchAutocomplete(args);
  });

  function highlightWord(text_id, search) {
    const terms = [...new Set(search.split(" "))].join("|");
    $(text_id).each(function (y) {
      $(this).html(
        $(this)
          .text()
          .replace(
            new RegExp(terms, "gi"),
            (match) => `<span class='marked'>${match}</span>`
          )
      );
    });
  }

  $('.total-results').on('click', function(e) {
    e.preventDefault();
    console.log('clicked');
    $('.site-search-form').submit();
  });
 
})(jQuery);
